// @flow

// PinRepSelectionBorder is a presentation-only component that draws a border
// around the Pin to convey selection.

import React from 'react';
import { Box } from 'gestalt';
import { PIN_BORDER_RADIUS } from 'app/common/react/components/PinRep/core/PinRepPresentation';

export const COLORS = {
  SELECTED: '#e60023',
  NOT_SELECTED: '#efefef',
};

type Props = {|
  selected: boolean,
|};

export default function PinRepSelectionBorder({ selected = false }: Props) {
  return (
    <Box
      position="absolute"
      top
      left
      bottom
      right
      dangerouslySetInlineStyle={{
        __style: {
          borderWidth: '3px',
          borderStyle: 'solid',
          borderColor: selected ? COLORS.SELECTED : COLORS.NOT_SELECTED,
          borderRadius: PIN_BORDER_RADIUS,
          boxShadow: 'inset 0 0 0 3px #fff',
          zIndex: 1,
        },
      }}
    />
  );
}
